import React, { useState } from "react";
import clsx from "clsx";
import { Button, Menu, MenuItem } from "@mui/material";

import styles from "./Search.module.scss";

export interface SearchProps {
  className?: string;
}

const Search = (props: SearchProps & { handleOpenCreate?: (type: string) => void }) => {
  const { className, handleOpenCreate } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (type: string) => {
    if (handleOpenCreate) handleOpenCreate(type);
    handleClose();
  };

  return (
    <div className={clsx(styles.root, className && className)}>
      <div className={styles.createBtnWrap}>
        <Button 
          variant="outlined" 
          color="error"
          className={styles.btnCreate} 
          onClick={handleClick}
          sx={{ textTransform: "none", fontWeight: "bold" }}
        >
          Tạo đơn mới
        </Button>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={() => handleSelect("donation")}>Cho tặng</MenuItem>
          <MenuItem onClick={() => handleSelect("zero_waste")}>Xử lý</MenuItem>
          <MenuItem onClick={() => handleSelect("recycle")}>Tái chế</MenuItem>
        </Menu>
      </div>
      <div className={styles.searchWrap}>
        <form action="">
          <div className={styles.inputWrap}>
            <input
              type="text"
              placeholder="Nhập mã túi"
              className={styles.input}
            />
          </div>

          <div className={styles.buttonWrap}>
            <button className={styles.button}>Xác nhận đã nhận hàng</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Search;
